<script lang="ts" setup>
  const { type } = defineProps<{
    type: string
  }>()
</script>

<template>
  <div>
    <div v-if="type !== 'card'" class="mb-4">
      <v-skeleton-loader
        class="rounded google-pay-skeleton"
        type="button"
      />
    </div>

    <div v-else>
      <!-- Card Number -->
      <div class="mb-4">
        <v-skeleton-loader class="d-flex bg-transparent mx-auto" type="text" />
        <v-skeleton-loader class="rounded" type="text@2" />
      </div>

      <!-- Expiry Date and CVV Row -->
      <div class="d-flex gap-4 mb-4">
        <div class="flex-fill">
          <v-skeleton-loader class="mb-2 bg-transparent" type="text" width="80" />
          <v-skeleton-loader class="rounded" type="text@2" />
        </div>
        <div class="flex-fill">
          <v-skeleton-loader class="mb-2 bg-transparent" type="text" width="60" />
          <v-skeleton-loader class="rounded" type="text@2" />
        </div>
      </div>

      <!-- Submit Button -->
      <div class="pt-4">
        <v-skeleton-loader
          class="rounded"
          type="button"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.google-pay-skeleton {
  background: linear-gradient(90deg, rgb(var(--v-theme-grey-600)) 40%, rgb(var(--v-theme-grey-800)) 50%, rgb(var(--v-theme-grey-800)) 50%) !important;
  background-size: 200% 100% !important;
  animation: shimmer 1.5s infinite !important;
}

.gap-4 {
  gap: 1rem;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
